import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import { ApiResponse } from "../../types/api.types";
import { Report } from "../../types/api.types";

export interface ExecuteReportResponse {
  columns: string[];
  rows: (string | number)[][] | Record<string, unknown>[];
}

export const reportService = {
  getReports: async (): Promise<Report[]> => {
    const response = await apiClient.get<ApiResponse<Report[]>>(
      ENDPOINTS.REPORTS.GET_ALL,
    );
    return response.data.data;
  },

  executeReport: async (
    reportId: number,
    parameters: Record<string, string>,
  ): Promise<ExecuteReportResponse> => {
    const response = await apiClient.post<ApiResponse<ExecuteReportResponse>>(
      ENDPOINTS.REPORTS.EXECUTE(reportId),
      { parameters },
    );
    return response.data?.data;
  },

  exportReport: async (
    reportId: number,
    parameters: Record<string, string>,
  ): Promise<Blob> => {
    const response = await apiClient.post<Blob>(
      ENDPOINTS.REPORTS.EXPORT(reportId),
      { parameters },
      { responseType: "blob" },
    );
    return response.data;
  },
};
